import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Facebook: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-540v-540h465c41.35 0 75 33.64 75 75zm-210-30h180v-435c0-24.81-20.19-45-45-45h-435v480z' />
    <path d='m355.2 568.57c.03-.79.09-34.96.09-35.78v-146.25h-48.11q-2.15 0-2.15-2.06c0-18.03.03-36.05-.03-54.05 0-1.67.48-2.06 2.06-2.06 15.36.06 30.72.03 46.08.03h2.15v-1.73c.03-15-.09-29.96.12-44.96.18-12.03 2.48-23.69 7.76-34.63 7.15-14.85 18.36-25.48 33.57-31.81 10.18-4.21 20.84-6.18 31.81-6.03 12.57.21 25.15.76 37.72 1.21 2.33.09 4.67.48 6.97.61 1.33.06 1.76.55 1.76 1.85-.06 7.45-.03 14.94-.03 22.39 0 8.79-.03 17.6.03 26.39 0 1.55-.42 2-1.97 2-9.54-.06-19.09-.18-28.63.03-4.33.09-8.73.58-12.97 1.48-8.15 1.82-13 7.21-14.6 15.33-.67 3.24-1.03 6.64-1.06 9.97-.15 12.21-.06 24.42-.06 36.63 0 .36.03.7.06 1.27h54.87c2.3 0 2.36 0 2.06 2.18-1.24 9.6-2.51 19.21-3.76 28.81-1.03 8.03-2.03 16.03-3 24.06-.36 3.06-.3 3.09-3.36 3.09h-46.87v145.13c0 1.18-.03 35.72-.06 36.9' />
  </IconBase>
));

Facebook.displayName = 'Facebook';

export default Facebook;
